import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class MenuService {

    //Observable string sources
    private menuClicked = new Subject<string>();


    //Observable string streams
    menuClicked$ = this.menuClicked.asObservable();

    //Service message commands
    announceMission(menuName: string) {
        this.menuClicked.next(menuName);
    }
}
